import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ChatbotComponent } from '../chatbot/chatbot.component';
@Component({
  selector: 'app-supplement',
  templateUrl: './supplement.component.html',
  styleUrls: ['./supplement.component.css']
})
export class SupplementComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
  }
  chatbot(){
    const dialogRef = this.dialog.open(ChatbotComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  newsletter:String="";
  subs(){
    if(this.newsletter!="")
    alert("Thanks for subscribing");
    else
    alert("Please mention your email");
  }

}
